import React from "react";
import { AppBar, Toolbar, Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

import AuthButtons from "../../components/AuthButtons";
import MarketTickerMarquee from "../components/MarketTickerMarquee";
import logo from "../../assets/images/logo.png";

const AppNavbar = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar
        position="sticky"
        sx={{
          background: "linear-gradient(180deg, rgba(2,6,23,.94) 0%, rgba(2,6,23,.78) 100%)",
          borderBottom: "1px solid rgba(255,255,255,.08)",
          boxShadow: "0 18px 60px rgba(2,8,23,.45)",
          backdropFilter: "blur(10px)",
          color: "#e5e7eb",
          zIndex: 1300, // ✅ выше сайдбара
        }}
      >
        <Toolbar
          sx={{
            minHeight: { xs: 68, sm: 84, md: 92 }, // ✅ чуть ниже на мобиле
            px: { xs: 1, sm: 2 },
            gap: 1.25,
          }}
        >
          {/* LOGO */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flexShrink: 0,
              cursor: "pointer",
              pr: 0.5,
            }}
            onClick={() => navigate("/market")}
          >
            <img
              src={logo}
              alt="PromosPay Logo"
              style={{
                height: isMobile ? 46 : 64, // ✅ компактнее на мобиле
                width: "auto",
                objectFit: "contain",
                display: "block",
              }}
            />
          </Box>

          {/* Ticker (desktop only) */}
          {!isMobile && (
            <Box sx={{ flex: "1 1 auto", minWidth: 0, maxWidth: "calc(100vw - 520px)", mx: 1 }}>
              <MarketTickerMarquee compact />
            </Box>
          )}

          {/* RIGHT */}
          <Box
            sx={{
              ml: "auto",
              display: "flex",
              alignItems: "center",
              gap: isMobile ? 0.75 : 1.25,
              flexShrink: 0,
              whiteSpace: "nowrap",
            }}
          >
            <AuthButtons compact={isMobile} />
          </Box>
        </Toolbar>

        {/* ticker (mobile row) */}
        {isMobile && (
          <Box sx={{ px: 1, pb: 0.75 }}>
            <Typography
              sx={{
                fontSize: 8, // ✅ “Market Puls” меньше
                fontWeight: 900,
                letterSpacing: ".12em",
                color: "rgba(229,231,235,.8)",
                textTransform: "uppercase",
                mb: 0.5,
              }}
            >
        
            </Typography>
            <MarketTickerMarquee compact />
          </Box>
        )}
      </AppBar>
    </Box>
  );
};

export default React.memo(AppNavbar);